import Actions from "@/elements/Actions";
import { updateExchange } from "@/store/features/stocksDetailsSlice";
import { useRouter } from "next/router";
import React from "react";
import { MdDisplaySettings, MdInsertLink } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";

export default function StockDetailsTopButton() {
    const dispatch = useDispatch();
    const router = useRouter();
    const {
        scripData,
        finCode,
        isOptionsEnabled,
        stockDetails,
        orderDetails,
        gttDetails,
        positionsDetails,
        holdingDetails
    } = useSelector((state) => state.stocksDetails);

    var details = orderDetails?.status
        ? orderDetails
        : gttDetails?.status
        ? gttDetails
        : holdingDetails?.smAdditionalDetailDto
        ? { ...holdingDetails, segment: "E" }
        : positionsDetails;
    const clickHandle = (lastparams) => {
        router.push(
            details?.segment === "E"
                ? Actions.toStockDetail(
                      stockDetails?.nseSymbol ?? stockDetails?.bseSymbol,
                      stockDetails?.compName,
                      lastparams
                  )
                : details?.segment === "I"
                ? Actions.toIndicesDetail(
                      stockDetails?.nseSymbol ?? stockDetails?.bseSymbol,
                      stockDetails?.compName,
                      lastparams
                  )
                : Actions.toFNODetail(`${stockDetails?.parentFinCode}-${stockDetails.finCode}`, lastparams)
        );
    };

    return (
        <div className="font-Inter mx-4">
            <div className="mt-4 flex justify-between items-center">
                <div
                    className="flex items-center gap-1 cursor-pointer"
                    onClick={() => {
                        dispatch(updateExchange(details?.mainExchange));
                        clickHandle(``);
                    }}
                >
                    <MdDisplaySettings className="w-4 h-4" color="#0862BC" />
                    <div className="font-semibold text-sm text-primary">Stock detail</div>
                </div>
                <div
                    className="flex items-center gap-1 cursor-pointer"
                    onClick={() => {
                        clickHandle("/charts");
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M2.25 7.72644V11.6364H5.9325V17.2734H9.8425V7.72644H2.25Z" fill="#0862BC" />
                        <path d="M13.1016 17.2734L17.1636 7.72644H21.7506L17.6886 17.2734H13.1016Z" fill="#0862BC" />
                        <path
                            d="M12.9199 11.6364C13.9996 11.6364 14.8749 10.7611 14.8749 9.68137C14.8749 8.60162 13.9996 7.72632 12.9199 7.72632C11.8401 7.72632 10.9648 8.60162 10.9648 9.68137C10.9648 10.7611 11.8401 11.6364 12.9199 11.6364Z"
                            fill="#0862BC"
                        />
                    </svg>
                    <div className="font-semibold text-sm text-primary">Chart</div>
                </div>
                {isOptionsEnabled && (
                    <div
                        className="flex items-center gap-1 cursor-pointer"
                        onClick={() => {
                            clickHandle("/option-chain");
                        }}
                    >
                        <MdInsertLink className="w-5 h-5" color="#0862BC" />
                        <div className="font-semibold text-sm text-primary">Option chain</div>
                    </div>
                )}
            </div>
            <hr className="my-4" />
        </div>
    );
}
